import { CardValidatorOrdered } from '../core/card/CardValidatorOrdered.ts';
export class MechanicValidatorProgressCardsPlayer {
    constructor(developmentCardPlayerState){
        this.progressCardsPlayerState = developmentCardPlayerState;
        this.progressCards = new CardValidatorOrdered(this.progressCardsPlayerState.progressCards);
    }
}
